function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "search-hi-dark_svg__a",
  x1: 117.26,
  y1: 117.17,
  x2: 171.99,
  y2: 171.9,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "search-hi-dark_svg__b",
  x1: 71.15,
  y1: 25.79,
  x2: 118.18,
  y2: 94.5,
  gradientTransform: "rotate(-10.61 75.987 75.977)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M158.82 147.41L115.39 104l-11.31 11.3 43.43 43.43a4 4 0 005.66 0l5.66-5.66a4 4 0 00-.01-5.66z",
  fill: "#e60000"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#4a4d4e",
  d: "M95.61 106.834l11.315-11.314 8.485 8.485-11.314 11.314z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M158.82 151.07l-5.66 5.66a4 4 0 01-5.66 0l-42.42-42.43-1 1 43.43 43.43a4 4 0 005.66 0l5.66-5.66a4 4 0 001-3.83 4 4 0 01-1.01 1.83z",
  fill: "#333",
  opacity: 0.12
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M174.82 163.41L131.41 120l-8.49-8.49-11.31 11.31 8.47 8.47 43.43 43.43a4 4 0 005.66 0l5.66-5.66a4 4 0 00-.01-5.65z",
  transform: "translate(-16 -16)",
  opacity: 0.2,
  fill: "url(#search-hi-dark_svg__a)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M60 10a50 50 0 1050 50 50.06 50.06 0 00-50-50z",
  fill: "#ccc"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M60 0a60 60 0 1060 60A60.07 60.07 0 0060 0zm0 110a50 50 0 1150-50 50.06 50.06 0 01-50 50z",
  fill: "#fff"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M60 0a60 60 0 1060 60A60.07 60.07 0 0060 0zm0 110a50 50 0 1150-50 50.06 50.06 0 01-50 50z",
  fill: "#333",
  opacity: 0.06
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M60 8a50.06 50.06 0 00-50 50v1a50 50 0 01100 0v-1A50.06 50.06 0 0060 8zM60 118A60.06 60.06 0 010 59v1a60 60 0 00120 0v-1a60.06 60.06 0 01-60 59z",
  fill: "#333",
  opacity: 0.06
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M101.21 39.18a44.7 44.7 0 00-51.82 1 2.1 2.1 0 001.55 3.77 57.85 57.85 0 0164 43.82 2.1 2.1 0 004.07.08 44.7 44.7 0 00-17.8-48.67z",
  transform: "translate(-16 -16)",
  fill: "url(#search-hi-dark_svg__b)"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 45.08,
  cy: 44.94,
  r: 2.1,
  transform: "matrix(.98 -.18 .18 .98 -23.5 -6.93)",
  fill: "#fff"
});

var SvgSearchHiDark = function SvgSearchHiDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Ebene 30",
    viewBox: "0 0 159.99 159.9",
    "aria-hidden": true
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

export default SvgSearchHiDark;